export default "__VITE_PUBLIC_ASSET__6c2cd32e__"